// extracted by mini-css-extract-plugin
export default {"wrapper":"IsI8f9Yp0Xz76Di_e1rH"};